import React, { useState, useEffect } from "react";
import axiosInstance from "../services/axiosInstance";

const SelectDriverPopup = ({
  openPopUp,
  closePopUp,
  fetchOrders,
  drivers,
  onDriverSelect,
  selectedRows,
}) => {
  const [selectedDriverId, setSelectedDriverId] = useState("");

  useEffect(() => {
    if (drivers && drivers.length > 0) {
      setSelectedDriverId(drivers[0].userId);
    }
  }, [drivers]);

  const handleDriverChange = (event) => {
    setSelectedDriverId(event.target.value);
  };

  const handleOrderStatusUpdate = async () => {
    await updateOrderStatusUpdate();
    onDriverSelect(selectedDriverId);
    closePopUp();
  };

  const updateOrderStatusUpdate = async () => {
    const selectedIds = selectedRows.map((row) => row.id);
    try {
      const response = await axiosInstance.post(
        "/api/Order/OrderTransferredToDriver",
        {
          orderIds: selectedIds,
          DriverId: selectedDriverId,
        }
      );
      //console.log("API response:", response);
      if (response.isSuccess) {
        closePopUp();
        await fetchOrders();
      } else {
        alert(response.message);
      }
    } catch (error) {
      console.error("Error sending selected IDs:", error);
    }
  };

  const handleCancelClick = () => {
    closePopUp();
  };

  if (!openPopUp) return null;

  return (
    <div
      id="ModelContainer"
      className="fixed inset-0 bg-black flex justify-center items-center bg-opacity-20 backdrop-blur-sm z-40"
    >
      <div className="relative bg-white w-5/6 xl:w-[400px] 3xl:w-[600px] text-center mx-auto rounded-[30px] p-10 pt-14 shadow-[0_0_7px_rgba(92,92,92,0.35)] drop-shadow-[0_0_4px_rgba(178,178,178,0.2)">
        <div className="w-full xl:w-4/5 text-center mx-auto">
          <h2 className="font-robotoBold text-gray-800 py-2 3xl:p-4 text-center text-3xl 3xl:text-4xl">
            Select Driver
          </h2>
          <select
            className="w-full p-2 border border-gray-300 rounded-md mb-4"
            value={selectedDriverId}
            onChange={handleDriverChange}
          >
            {drivers.map((driver) => (
              <option key={driver.userId} value={driver.userId}>
                {driver.userFirstName} {driver.userLastName}
              </option>
            ))}
          </select>
          <div className="flex justify-end gap-4">
            <button
              className="bg-white border border-blue text-blue-700 hover:bg-blue-50 font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
              type="button"
              onClick={handleCancelClick}
            >
              Abbrechen
            </button>
            <button
              className="bg-blue text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline hover:bg-blue-700"
              type="button"
              onClick={handleOrderStatusUpdate}
            >
              Speichern
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectDriverPopup;
